export default "__VITE_ASSET__BSvA6WJj__"